var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 8.76172L1.02344 3.44922C0.65625 3.08203 0.65625 2.48828 1.02344 2.125L1.90625 1.24219C2.27344 0.875 2.86719 0.875 3.23047 1.24219L6.99609 5.00781L10.7617 1.24219C11.1289 0.875 11.7227 0.875 12.0859 1.24219L12.9687 2.125C13.3359 2.49219 13.3359 3.08594 12.9687 3.44922L7.65625 8.76172C7.29688 9.12891 6.70312 9.12891 6.33594 8.76172Z",
    fill: "#358352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGreen);
export default __webpack_public_path__ + "static/media/arrowDown-green.d21ab51be7cab511b9b0fcaf468b1249.svg";
export { ForwardRef as ReactComponent };